import React, { useEffect } from 'react';
import { useSelector } from 'store';
import { useDispatch } from 'react-redux';
import { displayUserInfo } from 'store/ducks/user/actions';
import statementListActions from 'store/ducks/statements/actions';
import { getAccountInfo } from 'client/utils/token';
import { useHistory } from 'react-router-dom';
import { HeaderStyled, LogoContainer } from './styles';
import filterDates from 'store/ducks/filter/filter-dates';

// Todo: thing about how to develop it better
type CompanyNames =
  | 'AVENUE'
  | 'Avenue'
  | 'EBANX S/A'
  | 'Bexs Tecnologia da Informação LTDA'
  | 'REVOLUT TECNOLOGIA BRASIL LTDA';

interface CompanyLogo {
  path: string;
  width: number;
}

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { reportType } = useSelector().filter;

  const { isLoading, name } = useSelector().user;

  const generateCompanyLogo = (company: CompanyNames): CompanyLogo => {
    switch (company) {
      case 'AVENUE':
      case 'Avenue':
        return {
          path: 'https://storage.googleapis.com/bexs-forex-static/images/avenue.png',
          width: 40,
        };
      case 'Bexs Tecnologia da Informação LTDA':
        return {
          path: 'https://storage.googleapis.com/bexs-forex-static/images/ebury-bank-logo-black-horizontal.png',
          width: 140,
        };
      case 'EBANX S/A':
        return {
          path: 'https://storage.googleapis.com/bexs-forex-static/images/ebanxs.svg',
          width: 80,
        };
      case 'REVOLUT TECNOLOGIA BRASIL LTDA':
        return {
          path: 'https://storage.googleapis.com/bexs-forex-static/images/revolut.png',
          width: 90,
        };
      default:
        return {
          path: '',
          width: 0,
        };
    }
  };

  const logo = generateCompanyLogo(name as CompanyNames);

  useEffect(() => {
    /**
     * Unfortunately due to a wrong decision in the design of the Account back-end,
     * the account information is linked to the statement list response. That is,
     * to obtain the account information, it is necessary to request an entire list
     * of statements. This logic below tries to avoid unnecessary requests to the
     * server.
     */
    const accountInfo = getAccountInfo();
    if (accountInfo) {
      dispatch(displayUserInfo(accountInfo.Name));
      return;
    }

    if (history && history.location.pathname !== '/balance') {
      dispatch(
        statementListActions.request({
          periodStart: filterDates.tomorrow.date,
          periodEnd: filterDates.tomorrow.date,
          reportType,
        })
      );
    }
  }, [dispatch, reportType, history]);

  return (
    <HeaderStyled>
      <LogoContainer data-testid="logo-container" isLoaded={!isLoading}>
        <img width={logo.width} src={logo.path} alt={name} title={name} />
      </LogoContainer>
    </HeaderStyled>
  );
};

export default Header;
